module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahead2-23704b8ed381c7168035564be2767d78.jpg";